// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amhU8surKXU3EJRFOVY8{padding:9px 0 0}.MWCbkbMiNF4nrD5BydWQ{justify-content:space-between;align-items:center;margin-bottom:18px;display:flex}.ocFDBB8YELXgiCBJ0DWA{align-items:center;display:flex}.zGsBACAGXt0T2ODiEbUH{color:var(--content-primary-primary);font-size:13px;font-weight:500}.Sa_Bc1nCE11TBUwmhgFw>div{margin-right:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings": `amhU8surKXU3EJRFOVY8`,
	"settings__header": `MWCbkbMiNF4nrD5BydWQ`,
	"settingsHeader": `MWCbkbMiNF4nrD5BydWQ`,
	"settings__titleWrap": `ocFDBB8YELXgiCBJ0DWA`,
	"settingsTitleWrap": `ocFDBB8YELXgiCBJ0DWA`,
	"settings__title": `zGsBACAGXt0T2ODiEbUH`,
	"settingsTitle": `zGsBACAGXt0T2ODiEbUH`,
	"actionTitle": `Sa_Bc1nCE11TBUwmhgFw`
};
export default ___CSS_LOADER_EXPORT___;
